<template>
    <div>
        <div class="row">
            <div class="col-md-12 col-12 cyor_box mb-4 pb-2">
                <picture>
                    <source media="(min-width: 768px)" srcset="assets/landing/jewelry/cyo/cyor.webp" type="image/webp">
                    <source media="(min-width: 768px)" srcset="assets/landing/jewelry/cyo/cyor.jpg" type="image/jpeg">

                    <source media="(max-width: 1250px)" srcset="assets/landing/jewelry/cyo/cyor_mob.webp" type="image/webp">
                    <source media="(max-width: 1250px)" srcset="assets/landing/jewelry/cyo/cyor_mob.jpg" type="image/jpeg">

                    <img class="radious_eight" loading="lazy" alt="Create Your Own Ring" width="1788" height="382" src="assets/landing/jewelry/cyo/cyor.jpg" >
                </picture>
                <div class="cyor_upper cyor_upper_one radius_mod">
                    <h4 class="font-active">Create Your Own Ring</h4>
                    <p>Celebrate a milestone, occasion, anniversary, or birthday with a lab <br> diamond ring that you create.</p>
                    <NuxtLink class="anker radious_four" :to="localePath({ name:'cyo-setting-list-ring'})">Start with a Ring Setting</NuxtLink>
                </div>
            </div>

            <div class="col-md-6 col-12 cyor_box mb-4">
                <picture>
                    <source media="(min-width: 768px)" srcset="assets/landing/jewelry/cyo/cyop.webp" type="image/webp">
                    <source media="(min-width: 768px)" srcset="assets/landing/jewelry/cyo/cyop.jpg" type="image/jpeg">

                    <source media="(max-width: 992px)" srcset="assets/landing/jewelry/cyo/cyop_mob.webp" type="image/webp">
                    <source media="(max-width: 992px)" srcset="assets/landing/jewelry/cyo/cyop_mob.jpg" type="image/jpeg">

                    <img class="radious_eight" loading="lazy" alt="Create Your Own Pendant" width="880" height="382" src="assets/landing/jewelry/cyo/cyop.jpg">
                </picture>
                <div class="cyor_upper cyor_upper_two radius_mod">
                    <h4 class="font-active">Create Your Own <br> Pendant</h4>
                    <p>Discover our exquisite collection of pendant settings.</p>
                    <NuxtLink class="anker radious_four" :to="localePath({ name:'cyo-setting-list-pendant'})">Start with a Pendant Setting</NuxtLink>
                </div>
            </div>
            
            <div class="col-md-6 col-12 cyor_box mb-4">
                <picture>
                    <source media="(min-width: 768px)" srcset="assets/landing/jewelry/cyo/cyoe.webp" type="image/webp">
                    <source media="(min-width: 768px)" srcset="assets/landing/jewelry/cyo/cyoe.jpg" type="image/jpeg">

                    <source media="(max-width: 992px)" srcset="assets/landing/jewelry/cyo/cyoe_mob.webp" type="image/webp">
                    <source media="(max-width: 992px)" srcset="assets/landing/jewelry/cyo/cyoe_mob.jpg" type="image/jpeg">

                    <img class="radious_eight" loading="lazy" alt="Create Your Own Earrings" width="880" height="384" src="assets/landing/jewelry/cyo/cyoe.jpg">
                </picture>
                <div class="cyor_upper cyor_upper_two radius_mod">
                    <h4 class="font-active">Create Your Own <br> Earrings</h4>
                    <p>Choose from an elegant range of earring settings.</p>
                    <NuxtLink class="anker radious_four" :to="localePath({ name:'cyo-setting-list-earring'})">Start with an Earring Setting</NuxtLink>
                </div>
            </div>
            
        </div>
    </div>
</template>


<script setup></script>

<style scoped>

.cyor_box {
    position: relative;
}
.cyor_upper_one {
    position: absolute;
    top: 50%;
    left: 30%;
    transform: translate(-50%, -50%);
    width: 35%;
    text-align: left;
}
.cyor_upper_two {
    position: absolute;
    top: 50%;
    left: 75%;
    transform: translate(-50%, -50%);
    width: 46%;
    text-align: left;
}


.cyor_upper h4 {
    font-size: 32px;
   
}
.cyor_upper p {
    padding: 0;
}
a{
    display: inline-block;
    font-size: 13px;
    color: #000;
    border: 1px solid #000;
    text-transform: uppercase;
    font-weight: 600;
    padding: 8px 15px;
}
@media(max-width: 1500px){
    .cyor_upper_two {  
        left: 73%;    
        width: 46%;
    }
    .cyor_upper p br{
        display: none;
    }
    
}
@media(max-width: 1300px){
    .cyor_upper h4{
        font-size: 28px;
    }
    .cyor_upper h4,    .cyor_upper p{
        color: #000;
    }
}
@media(max-width: 1250px){
    .cyor_upper_one , .cyor_upper_two {
        left: 0;
        width: 100%;
        position: relative;
        transform: none;
        background: #f2e3da;
        top: 0;
        text-align: center;
        padding: 5%;
    }
    .radious_eight{
        border-radius: 8px 8px 0 0;
    }
    .radius_mod {
        border-radius: 0 0 8px 8px;
    }
}
@media(max-width: 1130px){
    .cyor_upper h4{
        font-size: 22px;
    }
    .cyor_upper p{
        font-size: 14px;
    }
 
}
@media(max-width: 992px){
    .cyor_upper_two {
        min-height: 190px;
    }
    .cyor_upper_two, .cyor_upper_one{
        position: relative;
        top: 0;
        left: 0;
        transform: none;
        width: 100%;
        text-align: center;
        padding: 5%;
        background: #f2e3da;
    }
    
    .cyor_upper h4 br{
        display:none;
    }
    a{
        padding: 7px 14px;
    }
    .cyor_upper h4{
        font-size: 24px
    }
    .cyor_upper p{
        font-size: 16px
    }
  
}

@media(max-width:767px){
  
    .cyor_upper h4{
        font-size: 24px
    }
    .cyor_upper p{
        font-size: 14px
    }
    .cyor_upper_two{
        padding: 10%;
    }
    a{
        color: #000;
        border-color: #000;
        padding: 10px 20px;
        width: 100%;
    }
    .col-12{
        padding: 0;
    }
    .row{
        margin-left: 0;
        margin-right: 0;
    }
}
</style>
